import { gql } from '@apollo/client';

export const GET_EXIT_STRATEGY_TEMPLATES = gql`
  query GetExitStrategyTemplates {
    exitStrategyTemplates {
      id
      name
      createdAt
      updatedAt
      targetMultiple
      baseSource
      exitLevelsCount
      exitLevelsSpread
      takeInitialsEnabled
      takeInitialsMultiple
      hodlEnabled
      hodlPercentage
      advancedDistributionEnabled
      distributionCurve
      distributionFocus
      distributionIntensity
      positionsCount
    }
  }
`;

export const GET_EXIT_STRATEGY_TEMPLATE = gql`
  query GetExitStrategyTemplate($id: ID!) {
    exitStrategyTemplate(id: $id) {
      id
      name
      createdAt
      updatedAt
      targetMultiple
      baseSource
      exitLevelsCount
      exitLevelsSpread
      takeInitialsEnabled
      takeInitialsMultiple
      hodlEnabled
      hodlPercentage
      advancedDistributionEnabled
      distributionCurve
      distributionFocus
      distributionIntensity
      positionsCount
    }
  }
`;

export const GET_INVALIDATION_STRATEGY_TEMPLATES = gql`
  query GetInvalidationStrategyTemplates {
    invalidationStrategyTemplates {
      id
      name
      createdAt
      updatedAt
      priceBasedEnabled
      priceDropPercentage
      timeBasedEnabled
      timeDurationDays
      positionsCount
    }
  }
`;

export const GET_INVALIDATION_STRATEGY_TEMPLATE = gql`
  query GetInvalidationStrategyTemplate($id: ID!) {
    invalidationStrategyTemplate(id: $id) {
      id
      name
      createdAt
      updatedAt
      priceBasedEnabled
      priceDropPercentage
      timeBasedEnabled
      timeDurationDays
      positionsCount
    }
  }
`;

export const GET_INVALIDATION_LEVEL = gql`
  query GetInvalidationLevel($portfolioId: ID!, $tokenId: ID!) {
    invalidationLevel(portfolioId: $portfolioId, tokenId: $tokenId) {
      id
      portfolioId
      tokenId
      triggerPrice
      timeDurationDays
      templateId
      templateName
      isModified
      isPriceTriggered
      isTimeTriggered
      currentPrice
      priceDropPercentRemaining
      daysHeld
      daysRemaining
    }
  }
`;
